import React from 'react'
import './FooterSection.css'
const FooterSection = () => {
  return (
    <>
    <footer>
    <p>© Copyright 2022 xyz company Pvt. Ltd. All Rights Reserved.</p>
    </footer>
    </>
  )
}

export default FooterSection